import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'edBeluga_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    reject: true,
    isLast: true,
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'edBeluga_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    type: 'info',
    isLast: true,
    reject: true,
    answer: {}
  },
  {
    field: 'edBeluga_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'edBeluga_sexAssignedAtBirth',
    extras: {
      sendToBeluga: false
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'edBeluga_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'edBeluga_height',
    type: 'info',
    answer: {
      name: 'edBeluga_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'edBeluga_weight',
    type: 'info',
    answer: {
      name: 'edBeluga_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label: 'Please identify all your current medical conditions',
    field: 'edBeluga_currentMedicalConditions',
    type: 'info',
    answer: {
      name: 'edBeluga_currentMedicalConditions',
      type: 'text',
      placeholder: 'Medical conditions'
    }
  },
  {
    label: 'Please list all your current medications including dosages',
    field: 'edBeluga_currentMedications',
    type: 'info',
    answer: {
      name: 'edBeluga_currentMedications',
      type: 'text',
      placeholder: 'Medications'
    }
  },
  {
    label: 'Please list all of your known allergies',
    field: 'edBeluga_knownAllergies',
    type: 'info',
    answer: {
      name: 'edBeluga_knownAllergies',
      type: 'text',
      placeholder: 'Allergies'
    }
  },
  {
    label:
      'Do you ever have a problem getting or maintaining an erection that is rigid enough for sex?',
    field: 'edBeluga_erectionProblem',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_erectionProblem_everyTime',
          value: 'Yes - every time'
        },
        {
          key: 'edBeluga_erectionProblem_moreThanHalf',
          value: 'Yes - more than half the time'
        },
        {
          key: 'edBeluga_erectionProblem_occasion',
          value: 'Yes - on occasion'
        },
        {
          key: 'edBeluga_erectionProblem_rarely',
          value: 'Yes - but rarely'
        },
        {
          key: 'edBeluga_erectionProblem_never',
          value:
            'I never have a problem getting or maintaining an erection for as long as I want'
        }
      ]
    }
  },
  {
    label: 'Do you get erections…',
    field: 'edBeluga_erectionTiming',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_erectionTiming_wakeUp',
          value: 'When you wake up'
        },
        {
          key: 'edBeluga_erectionTiming_otherTimes',
          value: 'Other times'
        },
        {
          key: 'edBeluga_erectionTiming_neither',
          value: 'Neither'
        }
      ]
    }
  },
  {
    label:
      'Have you ever been formally treated for ED or tried any medicines, vitamins, or supplements to treat it?',
    field: 'edBeluga_previousTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_previousTreatment_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_previousTreatment_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Please provide any details related to the treatment, dosage and effectiveness',
    field: 'edBeluga_previousTreatment_details',
    type: 'info',
    answer: {
      name: 'edBeluga_previousTreatment_details',
      type: 'text',
      placeholder: 'Treatment details'
    }
  },
  {
    label: 'Did you experience any side effects from your treatments for ED?',
    field: 'edBeluga_sideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_sideEffects_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_sideEffects_no',
          value: 'No, never had any side effects'
        }
      ]
    }
  },
  {
    label: 'Please explain any side effects you experienced.',
    field: 'edBeluga_sideEffects_details',
    type: 'info',
    answer: {
      name: 'edBeluga_sideEffects_details',
      type: 'text',
      placeholder: 'Side effect details'
    }
  },
  {
    label: 'How long ago was your last use of this medication?',
    field: 'edBeluga_lastMedicationUse',
    type: 'info',
    answer: {
      name: 'edBeluga_lastMedicationUse',
      type: 'text',
      placeholder: 'Time since last use'
    }
  },
  {
    label:
      'Have you had a physical exam with a healthcare provider in the past 5 years?',
    field: 'edBeluga_physicalExam',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_physicalExam_goodHealth',
          value: 'Yes, I am in good health'
        },
        {
          key: 'edBeluga_physicalExam_problems',
          value: 'Yes, but they found problems'
        },
        {
          key: 'edBeluga_physicalExam_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please explain any issues during your last physical exam',
    field: 'edBeluga_physicalExam_issues',
    type: 'info',
    answer: {
      name: 'edBeluga_physicalExam_issues',
      type: 'text',
      placeholder: 'Physical exam issues'
    }
  },
  {
    label: 'Was your blood pressure taken in the past year?',
    field: 'edBeluga_bloodPressure',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_bloodPressure_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_bloodPressure_no',
          value: 'No, I will get a new blood pressure measurement'
        }
      ]
    }
  },
  {
    label: 'What was your most recent blood pressure reading? (Example: 115/72)',
    field: 'edBeluga_bloodPressure_value',
    type: 'info',
    answer: {
      name: 'edBeluga_bloodPressure_value',
      type: 'text',
      placeholder: 'Blood pressure value'
    }
  },
  {
    label: 'Do any of the below apply to you?',
    field: 'edBeluga_bloodPressureHistory',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_bloodPressureHistory_high',
          value: 'I have a history of high blood pressure'
        },
        {
          key: 'edBeluga_bloodPressureHistory_low',
          value: 'I have a history of low blood pressure'
        },
        {
          key: 'edBeluga_bloodPressureHistory_normal',
          uncheckOthers: true,
          value:
            'My blood pressure has always been normal and has been checked within the last year'
        }
      ]
    }
  },
  {
    label: 'Do you take any of the following medicines? Select all that apply.',
    field: 'edBeluga_medications',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edBeluga_medications_nitroglycerin',
          value: 'Nitroglycerin spray, ointment, patches or tablets'
        },
        {
          key: 'edBeluga_medications_isosorbide',
          value:
            'Isosorbide mononitrate, or isosorbide dinitrate (Isordil, Dilatrate, Sorbitrate, Imdur, Ismo, Monoket)'
        },
        {
          key: 'edBeluga_medications_nitrates',
          value: 'Other medicines containing nitrates'
        },
        {
          key: 'edBeluga_medications_alphablockers',
          value:
            'Alpha blocker medications: doxazosin (Cardura), prazosin (Minipress), terazosin (Hytrin)'
        },
        {
          key: 'edBeluga_medications_riociguat',
          value: 'Riociguat (Adempas)'
        },
        {
          key: 'edBeluga_medications_none',
          value: 'None apply',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label:
      'Do any of the following cardiovascular risk factors apply to you? Select all that apply.',
    field: 'edBeluga_cardiovascularRisks',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edBeluga_cardiovascularRisks_diabetes',
          value: 'Diabetes'
        },
        {
          key: 'edBeluga_cardiovascularRisks_cholesterol',
          value: 'High cholesterol'
        },
        {
          key: 'edBeluga_cardiovascularRisks_bloodPressure',
          value: 'High blood pressure'
        },
        {
          key: 'edBeluga_cardiovascularRisks_fatherHeartAttack',
          value:
            'My father had a heart attack or heart disease at 55 years or younger'
        },
        {
          key: 'edBeluga_cardiovascularRisks_motherHeartAttack',
          value:
            'My mother had a heart attack or heart disease at 65 years or younger'
        },
        {
          key: 'edBeluga_cardiovascularRisks_none',
          value: 'None apply to me',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Tell us more about your diabetes.',
    educationalSlide: `When was your last Hemoglobin A1c checked and what was the value?`,
    field: 'edBeluga_cardiovascularRisks_diabetes_details',
    type: 'info',
    answer: {
      name: 'edBeluga_cardiovascularRisks_diabetes_details',
      type: 'text',
      placeholder: 'Diabetes details'
    }
  },
  {
    label: 'Tell us more about your high cholesterol',
    field: 'edBeluga_cardiovascularRisks_cholesterol_details',
    type: 'info',
    answer: {
      name: 'edBeluga_cardiovascularRisks_cholesterol_details',
      type: 'text',
      placeholder: 'Cholesterol details'
    }
  },
  {
    label: 'Tell us more about your high blood pressure',
    field: 'edBeluga_cardiovascularRisks_bloodPressure_details',
    type: 'info',
    answer: {
      name: 'edBeluga_cardiovascularRisks_bloodPressure_details',
      type: 'text',
      placeholder: 'Blood pressure details'
    }
  },

  {
    label:
      'Do you have or have you previously been diagnosed with any of the following? Check all that apply.',
    field: 'edBeluga_diagnoses',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edBeluga_diagnoses_prostateCancer',
          value: 'Prostate cancer'
        },
        {
          key: 'edBeluga_diagnoses_enlargedProstate',
          value: 'Enlarged prostate (BPH)'
        },
        {
          key: 'edBeluga_diagnoses_kidney',
          value: 'Kidney transplant or any condition affecting the kidney'
        },
        {
          key: 'edBeluga_diagnoses_liverDisease',
          value: 'Liver disease'
        },
        {
          key: 'edBeluga_diagnoses_ms',
          value: 'Multiple Sclerosis (MS) or similar disease'
        },
        {
          key: 'edBeluga_diagnoses_spinalInjuries',
          value: 'Spinal injuries and/or paralysis'
        },
        {
          key: 'edBeluga_diagnoses_neurological',
          value: 'Neurological diseases'
        },
        {
          key: 'edBeluga_diagnoses_ulcers',
          value: 'Stomach, intestinal, or bowel ulcers'
        },
        {
          key: 'edBeluga_diagnoses_arrhythmias',
          value: 'Heart arrhythmias (abnormal beating of the heart)'
        },
        {
          key: 'edBeluga_diagnoses_heartAbnormalities',
          value:
            'Any acquired, congenital, or developmental abnormalities of the heart including heart murmurs'
        },
        {
          key: 'edBeluga_diagnoses_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label:
      'Please tell us more about the diagnoses you selected (diagnosis and treatment).',
    field: 'edBeluga_diagnoses_details',
    type: 'info',
    answer: {
      name: 'edBeluga_diagnoses_details',
      type: 'text',
      placeholder: 'Diagnosis details'
    }
  },
  {
    label: 'Do you experience any of the following cardiovascular symptoms?',
    field: 'edBeluga_cardiovascularSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edBeluga_cardiovascularSymptoms_chestPainStairs',
          value:
            'Chest pain or shortness of breath when climbing 2 flights of stairs or walking 4 blocks'
        },
        {
          key: 'edBeluga_cardiovascularSymptoms_chestPainSex',
          value: 'Chest pain or shortness of breath with sexual activity'
        },
        {
          key: 'edBeluga_cardiovascularSymptoms_fainting',
          value: 'Unexplained fainting or dizziness'
        },
        {
          key: 'edBeluga_cardiovascularSymptoms_legCramps',
          value: 'Prolonged cramping of the legs with exercise'
        },
        {
          key: 'edBeluga_cardiovascularSymptoms_abnormalHeartbeats',
          value: 'Abnormal heart beats or rhythms'
        },
        {
          key: 'edBeluga_cardiovascularSymptoms_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your prolonged leg cramps.',
    field: 'edBeluga_cardiovascularSymptoms_legCramps_details',
    type: 'info',
    answer: {
      name: 'edBeluga_cardiovascularSymptoms_legCramps_details',
      type: 'text',
      placeholder: 'Leg cramps details'
    }
  },
  {
    label: 'Do you use any of the following recreational drugs?',
    educationalSlide: `Severe reactions may result if ED meds are used in conjunction with recreational drugs.`,
    field: 'edBeluga_recreationalDrugs',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edBeluga_recreationalDrugs_poppers',
          value: 'Poppers or Rush'
        },
        {
          key: 'edBeluga_recreationalDrugs_amylNitrate',
          value: 'Amyl Nitrate or Butyl Nitrate'
        },
        {
          key: 'edBeluga_recreationalDrugs_cocaine',
          value: 'Cocaine'
        },
        {
          key: 'edBeluga_recreationalDrugs_cigarettes',
          value: 'Cigarettes'
        },
        {
          key: 'edBeluga_recreationalDrugs_other',
          value: 'Other'
        },
        {
          key: 'edBeluga_recreationalDrugs_none',
          value: "No I don't use any of these",
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label:
      'Please explain your use of the drugs you selected. How frequently do you use them? When was the last time you used them?',
    field: 'edBeluga_recreationalDrugs_details',
    type: 'info',
    answer: {
      name: 'edBeluga_recreationalDrugs_details',
      type: 'text',
      placeholder: 'Drug use details'
    }
  },
  {
    label:
      "Do you have a marked curve or bend in the penis that interferes with sex, or Peyronie's Disease?",
    field: 'edBeluga_peyronies',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_peyronies_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_peyronies_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you had active bending of your penis within the last 12 months?',
    field: 'edBeluga_peyronies_12months',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_peyronies_12months_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_peyronies_12months_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you experience pain with erections or with ejaculation?',
    field: 'edBeluga_erectionPain',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_erectionPain_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_erectionPain_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you have a foreskin that is too tight?',
    field: 'edBeluga_tightForeskin',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_tightForeskin_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_tightForeskin_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you had active bending of your penis within the last 12 months?',
    field: 'edBeluga_activeBending',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_activeBending_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_activeBending_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do any of the below apply:',
    field: 'edBeluga_penileSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edBeluga_penileSymptoms_curve',
          value:
            "I have a marked curve or bend in the penis that interferes with sex, or Peyronie's Disease"
        },
        {
          key: 'edBeluga_penileSymptoms_pain',
          value: 'I experience pain with erections or with ejaculation'
        },
        {
          key: 'edBeluga_penileSymptoms_foreskin',
          value: 'I have a foreskin that is too tight'
        },
        {
          key: 'edBeluga_penileSymptoms_none',
          uncheckOthers: true,
          value: 'None of these apply to me'
        }
      ]
    }
  },
  {
    label:
      'Do you have now, or have you ever had any of the following conditions? Select all that apply.',
    field: 'edBeluga_otherConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'edBeluga_otherConditions_priapism',
          value: 'Priapism (erection lasting longer than 4 hours)'
        },
        {
          key: 'edBeluga_otherConditions_pah',
          value:
            'Pulmonary artery hypertension (elevated blood pressure of the lungs)'
        },
        {
          key: 'edBeluga_otherConditions_retinitisPigmentosa',
          value: 'Retinitis Pigmentosa'
        },
        {
          key: 'edBeluga_otherConditions_suddenVisionLoss',
          value: 'Sudden vision loss'
        },
        {
          key: 'edBeluga_otherConditions_bloodDisorders',
          value: 'Sickle cell anemia, Myeloma, Leukemia'
        },
        {
          key: 'edBeluga_otherConditions_ihss',
          value:
            'Idiopathic Hypertrophic Subaortic Stenosis/hypertrophic cardiomyopathy'
        },
        {
          key: 'edBeluga_otherConditions_icd',
          value: 'Placement of an implantable cardioverter defibrillator (ICD)'
        },
        {
          key: 'edBeluga_otherConditions_neurologicDisease',
          value: 'Neurologic disease or stroke'
        },
        {
          key: 'edBeluga_otherConditions_clottingDisorder',
          value: 'Blood clotting disorder, abnormal bleeding or bruising'
        },
        {
          key: 'edBeluga_otherConditions_stomachUlcer',
          value: 'Stomach or intestinal ulcer'
        },
        {
          key: 'edBeluga_otherConditions_heartAttack',
          value: 'A prior heart attack or heart failure'
        },
        {
          key: 'edBeluga_otherConditions_pad',
          value: 'Peripheral artery disease'
        },
        {
          key: 'edBeluga_otherConditions_qtProlongation',
          value: 'Any history of QT prolongation'
        },
        {
          key: 'edBeluga_otherConditions_bloodThinners',
          value: 'Use of blood thinners'
        },
        {
          key: 'edBeluga_otherConditions_none',
          value: 'None apply',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Have you had a heart attack within the last three months?',
    field: 'edBeluga_recentHeartAttack',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_recentHeartAttack_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_recentHeartAttack_no',
          value: 'No'
        }
      ]
    }
  },

  {
    label: 'Have you had a stroke within the last six months?',
    field: 'edBeluga_recentStroke',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_recentStroke_yes',
          value: 'Yes'
        },
        {
          key: 'edBeluga_recentStroke_no',
          value: 'No'
        }
      ]
    }
  },

  {
    label: 'Please tell us more about your conditions you selected.',
    field: 'edBeluga_otherConditions_details',

    type: 'info',

    answer: {
      name: 'edBeluga_otherConditions_details',
      type: 'text',
      placeholder: 'Condition details'
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'edBeluga_otherInformation',

    type: 'info',

    answer: {
      name: 'edBeluga_otherInformation',
      type: 'text',
      placeholder: 'Condition details'
    }
  },
  {
    label: 'Consent (PDE5 Inhibitor Treatment):',
    field: 'edBeluga_consent',
    type: 'select',
    educationalSlide: `Consent:\nYou have been diagnosed with or have reported that you have a known diagnosis of organic or psychogenic (situation) erectile dysfunction, a condition characterized by the inability to achieve or maintain an erection sufficient for satisfactory sexual performance. Phosphodiesterase Type 5 Inhibitors (PDE5i) are medications prescribed to treat this condition by enhancing erectile function.\nCommon PDE5 inhibitors include Sildenafil (Viagra), Tadalafil (Cialis), Vardenafil (Levitra), and Avanafil (Stendra). These medications work by increasing blood flow to the penis during sexual stimulation.\nThe use of PDE5 inhibitors may improve your ability to achieve and maintain an erection, enhance sexual performance and satisfaction, and improve your quality of life and personal relationships.\nWhile PDE5 inhibitors are generally well-tolerated, possible side effects may include headache, flushing, indigestion or upset stomach, nasal congestion, dizziness or lightheadedness, visual disturbances such as blurred vision or changes in color perception, back pain or muscle aches (more common with Tadalafil), hearing loss or ringing in the ears (rare), priapism (a prolonged erection lasting more than four hours), and allergic reactions like rash, itching, or swelling.\nDo not use PDE5 inhibitors if you take nitrates for chest pain (angina), use recreational drugs called "poppers" (amyl nitrate or nitrite), have severe heart or liver problems, have recently had a stroke or heart attack, or have low blood pressure.\nAlternative treatments include lifestyle changes such as exercise, weight loss, quitting smoking, and reducing alcohol intake; psychotherapy or counseling for psychological causes of erectile dysfunction; vacuum erection devices, which are mechanical pumps to induce erections; penile injections or suppositories where medications are administered directly to the penis; hormone therapy if low testosterone levels are contributing to erectile dysfunction; and surgical options like penile implants or vascular surgery.\nI understand the potential benefits, risks, and side effects of using PDE5 inhibitors. I have been informed about alternative treatment options. I agree to inform my healthcare provider of any side effects or adverse reactions I may experience. I understand that this consent is voluntary and that I can withdraw from treatment at any time.\nBy selecting below, I consent to the use of PDE5 inhibitors for the treatment of my erectile dysfunction.`,
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edBeluga_consent_non_consent',
          class: 'option-decline',
          value: 'I have read the information and I DO NOT wish to proceed'
        },
        {
          key: 'edBeluga_consent_consent',
          class: 'option-consent',
          value:
            'I have read and understand the information and I wish to proceed'
        }
      ]
    }
  }
];

export default questionsModels;

// 844#EDVISIT@1737825094817
// {
//   "formObj": {
//       "consentsSigned": true,
//       "firstName": "Ibrahim",
//       "lastName": "M",
//       "dob": "12/12/1999",
//       "phone": "6572392082",
//       "email": "ibrahim@appgen.ca",
//       "sex": "Male",
//       "address": "asd asd",
//       "city": "asd",
//       "state": "NY",
//       "zip": "10004",
//       "selfReportedMeds": "asd; asd",
//       "allergies": "Sulfa drugs",
//       "medicalConditions": "Heart disease; Irregular heartbeat",
//       "patientPreference": [
//           {
//               "name": "Sildenafil 25mg",
//               "strength": "0",
//               "quantity": "6",
//               "refills": "0",
//               "medId": "i4gbeBWSZBW7VfxRUQmkqlRDgImCzww5"
//           }
//       ],
//       "Q1": "What is your height in feet and inches?",
//       "A1": "123",
//       "Q2": "What is your weight in pounds?",
//       "A2": "123",
//       "Q3": "Do you ever have a problem getting or maintaining an erection that is rigid enough for sex? POSSIBLE ANSWERS: Yes - every time; Yes - more than half the time; Yes - on occasion; Yes - but rarely; I never have a problem getting or maintaining an erection for as long as I want",
//       "A3": "Yes - more than half the time",
//       "Q4": "Do you get erections... POSSIBLE ANSWERS: When you wake up; Other times; Neither",
//       "A4": "Other times",
//       "Q5": "Have you ever been formally treated for ED or tried any medicines, vitamins, or supplements to treat it? POSSIBLE ANSWERS: Yes; No",
//       "A5": "Yes",
//       "Q6": "Please provide any details related to the treatment, dosage and effectiveness",
//       "A6": "123",
//       "Q7": "Did you experience any side effects from your treatments for ED? POSSIBLE ANSWERS: Yes; No, never had any side effects",
//       "A7": "Yes",
//       "Q8": "Please explain any side effects you experienced.",
//       "A8": "123",
//       "Q9": "How long ago was your last use of this medication?",
//       "A9": "123",
//       "Q10": "Have you had a physical exam with a healthcare provider in the past 5 years? POSSIBLE ANSWERS: Yes, I am in good health; Yes, but they found problems; No",
//       "A10": "Yes, but they found problems",
//       "Q11": "Please explain any issues during your last physical exam",
//       "A11": "123",
//       "Q12": "Was your blood pressure taken in the past year? POSSIBLE ANSWERS: Yes; No, I will get a new blood pressure measurement",
//       "A12": "Yes",
//       "Q13": "What was the value? (Example: 115/72)",
//       "A13": "123",
//       "Q14": "Do you take any of the following medicines? POSSIBLE ANSWERS: Nitroglycerin spray, ointment, patches or tablets; Isosorbide mononitrate, or isosorbide dinitrate (Isordil, Dilatrate, Sorbitrate, Imdur, Ismo, Monoket); Other medicines containing nitrates; Alpha blocker medications: doxazosin (Cardura), prazosin (Minipress), terazosin (Hytrin); Riociguat (Adempas); None apply",
//       "A14": "Isosorbide mononitrate, or isosorbide dinitrate (Isordil, Dilatrate, Sorbitrate, Imdur, Ismo, Monoket)",
//       "Q15": "Do any of the following cardiovascular risk factors apply to you? POSSIBLE ANSWERS: Diabetes; High cholesterol; High blood pressure; My father had a heart attack or heart disease at 55 years or younger; My mother had a heart attack or heart disease at 65 years or younger; None apply to me",
//       "A15": "Diabetes; High cholesterol; High blood pressure; My father had a heart attack or heart disease at 55 years or younger",
//       "Q16": "Tell us more about your diabetes. When was your last Hemoglobin A1c checked and what was the value?",
//       "A16": "123",
//       "Q17": "Tell us more about your high cholesterol",
//       "A17": "123",
//       "Q18": "Tell us more about your high blood pressure",
//       "A18": "123",
//       "Q19": "Do you have or have you previously been diagnosed with any of the following? POSSIBLE ANSWERS: Prostate cancer; Enlarged prostate (BPH); Kidney transplant or any condition affecting the kidney; Pulmonary artery hypertension (PAH); Liver disease; Multiple Sclerosis (MS) or similar disease; Spinal injuries and/or paralysis; Neurological diseases; Stomach, intestinal, or bowel ulcers; Heart arrhythmias (abnormal beating of the heart); Any acquired, congenital, or developmental abnormalities of the heart including heart murmurs; None of these apply to me",
//       "A19": "Liver disease; Neurological diseases; Stomach, intestinal, or bowel ulcers",
//       "Q20": "Please tell us more about the diagnoses you selected (diagnosis and treatment)",
//       "A20": "123",
//       "Q21": "Do you experience any of the following cardiovascular symptoms? POSSIBLE ANSWERS: Chest pain or shortness of breath when climbing 2 flights of stairs or walking 4 blocks; Chest pain or shortness of breath with sexual activity; Unexplained fainting or dizziness; Prolonged cramping of the legs with exercise; Abnormal heart beats or rhythms; None of these apply to me",
//       "A21": "Prolonged cramping of the legs with exercise",
//       "Q22": "Please tell us more about your prolonged leg cramps",
//       "A22": "123",
//       "Q23": "Do you use any of the following recreational drugs?Severe reactions may result if ED meds are used in conjunction with recreational drugs POSSIBLE ANSWERS: Poppers or Rush; Amyl Nitrate or Butyl Nitrate; Cocaine; Cigarettes; Other; No I don't use any of these",
//       "A23": "Poppers or Rush; Cigarettes",
//       "Q24": "Please explain your use of the drugs you selected. How frequently do you use them? When was the last time you used them?",
//       "A24": "123",
//       "Q25": "Do you have a marked curve or bend in the penis that interferes with sex, or Peyronie's Disease? POSSIBLE ANSWERS: Yes; No",
//       "A25": "Yes",
//       "Q26": "Have you had active bending of your penis within the last 12 months? POSSIBLE ANSWERS: Yes; No",
//       "A26": "No",
//       "Q27": "Do you experience pain with erections or with ejaculation? POSSIBLE ANSWERS: Yes; No",
//       "A27": "No",
//       "Q28": "Do you have a foreskin that is too tight? POSSIBLE ANSWERS: Yes; No",
//       "A28": "No",
//       "Q29": "Do you have now, or have you ever had any of the following conditions? POSSIBLE ANSWERS: Priapism (erection lasting longer than 4 hours); Retinitis Pigmentosa; Sudden vision loss; Neurologic disease or stroke; Blood clotting disorder, abnormal bleeding or bruising; Stomach or intestinal ulcer; A prior heart attack or heart failure; Peripheral artery disease; Any history of QT prolongation; Sickle cell anemia, Myeloma, Leukemia; Idiopathic Hypertrophic Subaortic Stenosis; Use of blood thinners; None apply",
//       "A29": "Blood clotting disorder, abnormal bleeding or bruising; A prior heart attack or heart failure",
//       "Q30": "Have you had a heart attack in the last three months? POSSIBLE ANSWERS: Yes; No",
//       "A30": "No",
//       "Q31": "Please tell us more about your conditions you selected.",
//       "A31": "123",
//       "Q32": "What other information or questions do you have for the doctor?",
//       "A32": "123",
//       "Q33": "Consent (PDE5 Inhibitor Treatment):Consent:\nYou have been diagnosed with or have reported that you have a known diagnosis of organic or psychogenic (situation) erectile dysfunction, a condition characterized by the inability to achieve or maintain an erection sufficient for satisfactory sexual performance. Phosphodiesterase Type 5 Inhibitors (PDE5i) are medications prescribed to treat this condition by enhancing erectile function.\nCommon PDE5 inhibitors include Sildenafil (Viagra), Tadalafil (Cialis), Vardenafil (Levitra), and Avanafil (Stendra). These medications work by increasing blood flow to the penis during sexual stimulation.\nThe use of PDE5 inhibitors may improve your ability to achieve and maintain an erection, enhance sexual performance and satisfaction, and improve your quality of life and personal relationships.\nWhile PDE5 inhibitors are generally well-tolerated, possible side effects may include headache, flushing, indigestion or upset stomach, nasal congestion, dizziness or lightheadedness, visual disturbances such as blurred vision or changes in color perception, back pain or muscle aches (more common with Tadalafil), hearing loss or ringing in the ears (rare), priapism (a prolonged erection lasting more than four hours), and allergic reactions like rash, itching, or swelling.\nDo not use PDE5 inhibitors if you take nitrates for chest pain (angina), use recreational drugs called \"poppers\" (amyl nitrate or nitrite), have severe heart or liver problems, have recently had a stroke or heart attack, or have low blood pressure.\nAlternative treatments include lifestyle changes such as exercise, weight loss, quitting smoking, and reducing alcohol intake; psychotherapy or counseling for psychological causes of erectile dysfunction; vacuum erection devices, which are mechanical pumps to induce erections; penile injections or suppositories where medications are administered directly to the penis; hormone therapy if low testosterone levels are contributing to erectile dysfunction; and surgical options like penile implants or vascular surgery.\nI understand the potential benefits, risks, and side effects of using PDE5 inhibitors. I have been informed about alternative treatment options. I agree to inform my healthcare provider of any side effects or adverse reactions I may experience. I understand that this consent is voluntary and that I can withdraw from treatment at any time.\nBy selecting below, I consent to the use of PDE5 inhibitors for the treatment of my erectile dysfunction. POSSIBLE ANSWERS: I have read and understand the information and I wish to proceed; I have read the information and I DO NOT wish to proceed",
//       "A33": "I have read and understand the information and I wish to proceed"
//   },
//   "pharmacyId": "29992",
//   "masterId": "844#EDVISIT@1737825094817",
//   "company": "carePortalsMandos",
//   "visitType": "ED"
// }

